import { useEffect } from "react";
import { useIonToast } from "@ionic/react";
import { registerToast } from "@/utils/toast";

// Mount once at the app root. Wires the imperative showToast() bridge to
// Ionic's toast presenter so notifications can be fired from anywhere in the
// app — same pattern as the whodat Toaster host.
const IonToaster = () => {
  const [present, dismiss] = useIonToast();
  // useIonToast ignores present() while its toast is still up, so a message
  // fired right after another (an error after "Employee added") would be
  // lost: the newest message replaces the one showing.
  useEffect(() => registerToast(async (cfg) => { try { await dismiss(); } catch (e) {} present(cfg); }), [present, dismiss]);
  return null;
};

export default IonToaster;
